import MicIcon from '@mui/icons-material/Mic';
import Typography from '@mui/material/Typography';
import { getSentence } from './translations';
import FileUploadIcon from '@mui/icons-material/FileUpload';


export function tutoMainPage()
{
    //Tutorial about how to launch a new recording and how to upload a file.
    var msg = <Typography variant="h5" >
                {getSentence(42)} <MicIcon /> {getSentence(43)} <br/> 
                <br/> 
                {getSentence(65)} 
                <br/> 
                <br/> {getSentence(122)} <FileUploadIcon /> {getSentence(66)}
            </Typography>


    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            heigth: "100%",
            marginLeft: "20px",
            marginRight: "20px",
        }}>
            {msg}
        </div>
      )
}